import { render, staticRenderFns } from "./FieldOverviewNDVI.vue?vue&type=template&id=78966d7a&scoped=true"
import script from "./FieldOverviewNDVI.vue?vue&type=script&lang=js"
export * from "./FieldOverviewNDVI.vue?vue&type=script&lang=js"
import style0 from "./FieldOverviewNDVI.vue?vue&type=style&index=0&id=78966d7a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78966d7a",
  null
  
)

export default component.exports